const mFeedMapsContentModalDuplicate = {
  mFeedMapsContentModalDuplicate: {
    alerts: {
      createMapaClonar: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El mapa fue duplicado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ENTENDIDO',

    messageDelete: {
      element: 'Se duplicará el mapa',
      options: 'y todas sus características.'
    },
    messageRevision: {
      element: 'Lo sentimos, ésta función está deshabilitada momentáneamente.'
    },
    title: 'Duplicar Mapa'
  }
}

export default mFeedMapsContentModalDuplicate
